<template>
  <div class='massLoss-list'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='140px' :inline='true'
               class='demo-form-inline flex1'>
        <el-form-item label='业务单位：'>
          <el-input v-model='searchForm.businessUnit' size='mini' placeholder='请输入业务单位' />
        </el-form-item>
        <el-form-item label='业务类型：'>
          <el-select v-model='searchForm.businessType' clearable filterable size='mini'
                     placeholder='请选择业务单位'>
            <el-option :label='"全部"' value='' />
            <el-option v-for='item in selectedData.attrList2' :key='item.id'
                       :label='item.classaName' :value='item.classaName' />
          </el-select>
        </el-form-item>
        <el-form-item label='业务板块：'>
          <el-select v-model='searchForm.businesSegment' clearable filterable size='mini'
                     placeholder='请选择业务板块'>
            <el-option :label='"全部"' value='' />
            <el-option v-for='item in selectedData.attrList3' :key='item.id'
                       :label='item.classaName' :value='item.classaName' />
          </el-select>
        </el-form-item>
        <el-form-item label='联运类型：'>
          <el-select v-model='searchForm.transportType' clearable filterable size='mini'
                     placeholder='请选择联运类型'>
            <el-option :label='"全部"' value='' />
            <el-option v-for='item in selectedData.attrList4' :key='item.id'
                       :label='item.classaName' :value='item.classaName' />
          </el-select>
        </el-form-item>
        <el-form-item label='货类：'>
          <el-select v-model='searchForm.goods' clearable filterable size='mini'
                     placeholder='请选择货类'>
            <el-option :label='"全部"' value='' />
            <el-option v-for='item in selectedData.attrList5' :key='item.id'
                       :label='item.classaName' :value='item.classaName' />
          </el-select>
        </el-form-item>
        <el-form-item label='是否固定资产业务：'>
          <el-select v-model='searchForm.fixedBusiness' filterable size='mini'
                     placeholder='请选择是否固定资产业务'>
            <el-option :label='"全部"' value='' />
            <el-option v-for='item in selectedData.attrList8' :key='item.id'
                       :label='item.classaName' :value='item.classaName' />
          </el-select>
        </el-form-item>
        <el-form-item label="起始日期：">
          <el-date-picker v-model='searchForm.settlementStartYears' size='mini' style='width:150px'
                          value-format='yyyy' @change='dateChange' type='year'
                          placeholder='开始日期' />
          <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
          <el-date-picker v-model='searchForm.settlementEndYears' size='mini' style='width:150px'
                          value-format='yyyy' @change='dateChange' type='year'
                          placeholder='结束日期' />
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
<!--          <el-button size='small' class='searchBtn' :loading='refreshLoading'-->
<!--                     @click='btnClick("refresh")'>刷新-->
<!--          </el-button>-->
<!--          <el-button size='small' class='searchBtn' @click='btnClick("submitSummary")'>提交汇总-->
<!--          </el-button>-->
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          ref='registerTable'
          row-key='id'
          v-loading='tableLoading'
          :data='tableData'
          max-height='600'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
          @select='handleCurrentChange'
          @select-all='handleCurrentChange'
          :row-style="rowStyle"
        >
          <el-table-column type='selection' align='center' width='50px' :reserve-selection='true'
                           :selectable='(row)=>{return row.type !== 1}' />
          <el-table-column prop='years' label='时间' align='center' min-width='120' />
          <el-table-column prop='businessUnit' label='业务单位' align='center' min-width='120' />
          <el-table-column prop='businessType' label='业务类型' align='center' min-width='120' />
          <el-table-column prop='businesSegment' label='业务板块' align='center' min-width='120' />
          <el-table-column prop='transportType' label='联运类型' align='center' min-width='120' />
          <el-table-column prop='goods' label='货类' align='center' min-width='120' />
          <el-table-column prop='fixedBusiness' label='是否固定资产业务' align='center' min-width='140' />
          <el-table-column prop='meteringCompany' label='计量单位' align='center' min-width='80' />
          <el-table-column prop='businessVolume' label='业务量' align='center' min-width='80' />
          <el-table-column prop='weight' label='重量' align='center' min-width='80' />
          <el-table-column prop='taxExcluded' label='不含税收入' align='center' min-width='80' />
<!--          <el-table-column prop='type' label='状态' align='center' min-width='80'>-->
<!--            <template slot-scope='scope'>-->
<!--              {{ scope.row.type === 0 ? '待提交' : scope.row.type === 1 ? '已提交' : '退回' }}-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>
  </div>
</template>

<script>
  import {
    monthlySummaryMonthQuery,
    summaryYearPage, summaryYearRefreshData,
    summaryYearSubmit,
  } from '@/service/financial';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';

  export default {
    name: 'year',
    data() {
      return {
        searchForm: {
          businessUnit: '',
          businessType: '',
          businesSegment: '',
          transportType: '',
          goods: '',
          fixedBusiness: '',
          settlementStartYears:'',
          settlementEndYears:'',
          page: 1,
          rows: 10,
        },
        defaultSearchForm: {},
        refreshLoading: false,
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
        checkTableData: [],
        selectedData: {},
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      this.getSelectedData();
      // this.searchBtn();
    },
    methods: {
      async getSelectedData() {
        const {
          status,
          message,
          data,
        } = await monthlySummaryMonthQuery();
        if (status !== 0) return this.message.warning(message);
        this.selectedData = data;
      },
      async btnClick(str, row) {
        switch (str) {
          case 'refresh':
            this.refreshLoading = true;
            const {
              status,
              message,
            } = await summaryYearRefreshData();
            this.refreshLoading = false;
            this.$alert(message, '提示', {
              confirmButtonText: '关闭',
              type: status !== 0 ? 'warning' : 'success',
            })
              .then(async () => {
                await this.getTableData();
              })
              .catch(() => {
              });
            break;
          case 'submitSummary':
            if (this.checkTableData === null || this.checkTableData.length === 0) return this.$message.warning('请选择数据后提交汇总');
            this.$confirm('确认提交当前选中数据吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
              .then(async () => {
                const ids = [];
                this.checkTableData.forEach(item => {
                  ids.push(item.id);
                });
                const {
                  status,
                  message,
                } = await summaryYearSubmit({ ids });
                if (status !== 0) return this.$message.warning(message);
                this.$message.success(message);
                await this.clearCheckTableData();
              })
              .catch();
        }
      },
      // 结束时间
      dateChange(val) {
        if (this.searchForm.settlementEndYears && this.searchForm.settlementStartYears && (this.searchForm.settlementEndYears < this.searchForm.settlementStartYears)) {
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      clearCheckTableData() {
        this.$refs.registerTable.clearSelection();
        this.checkTableData = [];
        this.getTableData();
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/monthly/summary/year/exportData?access_token=${token}&businessUnit=${this.searchForm.businessUnit}&businessType=${this.searchForm.businessType}&businesSegment=${this.searchForm.businesSegment}&transportType=${this.searchForm.transportType}&goods=${this.searchForm.goods}&fixedBusiness=${this.searchForm.fixedBusiness}`;
        window.exportExcelGet('/platform/monthly/summary/year/exportData', `businessUnit=${this.searchForm.businessUnit}&businessType=${this.searchForm.businessType}&businesSegment=${this.searchForm.businesSegment}&transportType=${this.searchForm.transportType}&goods=${this.searchForm.goods}&fixedBusiness=${this.searchForm.fixedBusiness}`)
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const data = await summaryYearPage(this.searchForm);
        this.tableLoading = false;
        this.tableData = data.data.records;
        this.total = data.data.total;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      // 多选事件触发
      handleCurrentChange(val) {
        this.checkTableData = val;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
    },
  };
</script>


<style lang='scss' scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/

    .tabs {
      //float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 239px;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599E;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599E;
        font-weight: 700;
        transition: all .3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        /*width: 160px;*/
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      .active {
        background: #48599E;
        color: #fff;
      }
    }

    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }


        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }


    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }

            }

          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }

        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }

    }

  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      margin-right: 10px;
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
